import { CLIENT_TYPE } from "@hub/order/src/constants"

export default {
  getType: state => state.type,
  getTypeText: state =>
    CLIENT_TYPE.find(({ value }) => value == state.type)?.text,
  getDocument: state => state.document,
  getRG: state => state.rg,
  getGeneralRegistrationExempt: state => state.generalRegistrationExempt,
  getName: state => state.name,
  getBirthDate: state => state.birthDate,
  getMotherName: state => state.motherName,
  getFatherName: state => state.fatherName,
  getGender: state => state.gender,
  getSchooled: state => state.schooled,
  getMaritalStatus: state => state.maritalStatus,
  getProfession: state => state.profession,
  getProfessionName: state => state.professionName,
  getContactType: state => state.contactType,

  getCompanyName: state => state.companyName,
  getCompanyType: state => state.companyType,
  getCompanyState: state => state.companyState,
  getStateId: state => state.stateId,
  getOpeningDate: state => state.openingDate,
  getResponsible: state => state.responsible,
  getResponsibleName: state => state.responsible.name,
  getResponsibleCpf: state => state.responsible.cpf,
  getState: state => state.state,
  getStateRegistration: state => state.stateRegistration,
  getExempt: state => state.exempt,
  getContactName: state => state.contactName,

  getEmail: state => state.email,
  getCellphone: state => state.cellphone,
  getLandline: state => state.landline,
  getAnotherContact: state => state.anotherContact,
  getWhatsappContact: state => state.whatsappContact,

  isSaved: state => state.isSaved,
  clientId: state => state.clientId,
  isAnotherContactReturnedFilled: state => state.isAnotherContactReturnedFilled,

  getLegalPayload: state => state.legalPayload,
  getLegalResponsibles: state => state.legalResponsibles,

  getCompanyTypesOptions: state => state.companyTypesOptions,
  getIsCompanyTypeFromBepeople: state => state.isCompanyTypeFromBepeople,
  getIsCompanyStateFromBepeople: state => state.isCompanyStateFromBepeople,
  getIsRetroactiveCompanyType: state => state.isRetroactiveCompanyType,
  getCustomerOrigin: state => state.customerOrigin
}
